import { useBooleanFlagValue, useObjectFlagValue } from '@openfeature/react-sdk';

/**
 * Flagsmith JSON config for the Work-home "Set your default page" banner: how
 * long after the Heidi II onboarding banner is dismissed it may first appear,
 * e.g. `{ "waitMinutes": 1440 }`. A rollout knob, not an experiment.
 */
export const DEFAULT_LANDING_PAGE_BANNER_WAIT_FLAG_KEY =
  'config-scribe-default-landing-page-banner-wait';

/** Built-in wait when the flag is off, unset or malformed. */
export const DEFAULT_LANDING_PAGE_BANNER_WAIT_MS = 24 * 60 * 60 * 1000;

const MS_PER_MINUTE = 60 * 1000;

/** `waitMinutes` as milliseconds when it is a positive safe integer, else the default. */
export const parseDefaultLandingPageBannerWaitMs = (payload: unknown): number => {
  const waitMinutes = (payload as { waitMinutes?: unknown } | null)?.waitMinutes;
  return typeof waitMinutes === 'number' &&
    Number.isSafeInteger(waitMinutes) &&
    waitMinutes >= 1
    ? waitMinutes * MS_PER_MINUTE
    : DEFAULT_LANDING_PAGE_BANNER_WAIT_MS;
};

export const useDefaultLandingPageBannerWaitMs = (): number => {
  // The payload is returned even when the flag is toggled off, so gate on the
  // enabled state: off or unset keeps the built-in wait.
  const enabled = useBooleanFlagValue(DEFAULT_LANDING_PAGE_BANNER_WAIT_FLAG_KEY, false);
  const payload = useObjectFlagValue(DEFAULT_LANDING_PAGE_BANNER_WAIT_FLAG_KEY, {});
  return enabled
    ? parseDefaultLandingPageBannerWaitMs(payload)
    : DEFAULT_LANDING_PAGE_BANNER_WAIT_MS;
};
